import { render, staticRenderFns } from "./AlignCenterIcon.vue?vue&type=template&id=9d8a9748&"
import script from "./AlignCenterIcon.vue?vue&type=script&lang=js&"
export * from "./AlignCenterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports